<template>
  <div>
    <grid-layout
        :layout.sync="layout"
        :col-num="12"
        :row-height="30"
        :is-draggable="true"
        :is-resizable="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="true"
        :responsive="true"
    >
      <grid-item
          v-for="(anApp, i)  in apps"
          style="background-color: #dcb85c; border-radius: 15px;"
          :x="layout[i].x"
          :y="layout[i].y"
          :w="layout[i].w"
          :h="layout[i].h"
          :i="layout[i].i"
          :key="layout[i].i"
      >
        <block
            :resource="anApp"
            @icon-click="handleIconClick"
        />
      </grid-item>
    </grid-layout>
    <block-shelf-resources
        v-if="apps && Array.isArray(apps) && heartbeat"
        :ref="blockShelfResourceRef"
        :viewing-id="heartbeat.uid"
        :apps="apps"
        :display-app-icons="false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueGridLayout from "vue-grid-layout";
import Block from "./block";
import BlockShelfResources from "@/components/blockShelfResources";
export default {
  name: "HeartBeat_Body_App",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Block,
    BlockShelfResources
  },
  created(){},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      required: true,
      default: () => {}
    },
    apps: {
      type: Array,
      required: true,
      default: () => {return []}
    },
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
  },
  methods: {
    handleIconClick(resource) {
      debugger;
      if (this.$refs[this.blockShelfResourceRef].hasOwnProperty('handleResourceReveal')){
        this.$refs[this.blockShelfResourceRef].handleResourceReveal(resource);
      }
    }
  },
  data() {
    return {
      blockShelfResourceRef:"resources",
      layout: [
        { x: 0, y: 0, w: 3, h: 10, i: "0" },
        { x: 3, y: 0, w: 3, h: 10, i: "1" },
        { x: 6, y: 0, w: 3, h: 10, i: "2" },
        { x: 0, y: 3, w: 3, h: 10, i: "3" },
        { x: 3, y: 3, w: 3, h: 10, i: "4" },
        { x: 6, y: 3, w: 3, h: 10, i: "5" },
        { x: 0, y: 6, w: 3, h: 10, i: "6" },
        { x: 3, y: 6, w: 3, h: 10, i: "7" },
        { x: 6, y: 6, w: 3, h: 10, i: "8" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>